
import Vue from "vue";
import Component from "vue-class-component";
import InputForm from "@/components/base/form/InputForm.vue";
import { Getter, State, Action } from "vuex-class";
import { FormConfig, FormValid } from "@/config";
@Component({
	name: "UnitBasic",
	components: { InputForm }
})
export default class UnitBasic extends Vue {
	@State("basic") private basic: any;
	@Getter("id") private id: any;
	@Getter("save") private isSave: any;
	@Getter("unitId") private unitId: any;
	isAuthern: number = 0;
	@Action("account/getBasic") private getBasic: any;
	@Action("account/addBasic") private addBasic: any;
	$https: any;
	isEdit = false;
	formName: any = "CompanyBaseInfo";
	currentPage = 0;
	labelWidth: any = "180px";
	labelPosition: any = "left";
	btnData = "基本信息";
	// btnData = [
	//   "基本信息", "财务信息", "附件信息",
	// ];
	socialIdCard: any = this.$store.state.account.socialIdCard;
	input = "";
	formData: any = {
		cName: "",
		socialIdCard: this.socialIdCard || "",
		unitNature: "",
		unitType: "",
		industry: "",
		techField: "",
		coAddress: "",
		address: "",
		reCapital: ""
	};
	setting: any = [
		{
			label: "企业名称",
			ref: "cName",
			type: "text",
			span: 12,
			disabled: true,
			required: true
		},
		{
			label: "统一社会信用代码",
			ref: "socialIdCard",
			type: "text",
			span: 12,
			disabled: true,
			required: true
		},
		{
			label: "企业类型",
			type: "text",
			ref: "unitType",
			options: FormConfig.unit_type,
			span: 12,
			disabled: true,
			required: true
		},
		{
			label: "所属行业",
			ref: "industry",
			span: 12,
			options: FormConfig.industry,
			double: true,
			type: "text",
			disabled: true,
			required: true
		},
		{
			label: "注册所在地",
			ref: "coAddress",
			span: 12,
			type: "text",
			disabled: true,
			required: true
		},
		{
			label: "注册地址",
			ref: "address",
			span: 12,
			type: "text",
			disabled: true,
			required: true
		},
		{
			label: "注册资本",
			ref: "reCapital",
			span: 12,
			disabled: true,
			type: "text",
			required: true
		}
	];
	state = 0;
	edit() {
		this.isEdit = true;
		this.setting.forEach((el: any) => {
			if (this.isAuthern !== 1) {
				el.type = "input";
			} else {
				if (el.ref !== "cName" && el.ref !== "socialIdCard") {
					el.type = "input";
				}
			}
		});
	}
	created() {
		this.getSaveData();

		// if(this.isSave === 1) {
		//   this.setStatus();
		// }
	}
	setStatus() {
		this.isEdit = false;
		this.setting.forEach((el: any) => {
			el.type = "text";
		});
	}
	getSaveData() {
		const options = { unitId: this.id };
		this.getBasic(options).then(({ code, data, msg }: any) => {
			if (code === 0 && data) {
				const { soleSave, idState } = data;
				if (soleSave === 0) {
					this.$message.warning("请先进行实名认证");
				}
				this.isAuthern = soleSave;
				this.setting.map((item: any) => {
					let disList = ["socialIdCard", "cName"];
					if (disList.includes(item.ref)) {
						item.disabled = true;
					}
					return item;
				});
				const { unitCode } = data;
				if (soleSave === 1) {
					let {
						creditCode,
						unitName,
						organizationType,
						theirIndustry,
						belongsToField,
						signInAddress,
						detailedAddress,
						registeredAddress,
						registeredCapital
					} = unitCode;
					// 实名认证数据
					this.formData.socialIdCard = creditCode || null;
					this.formData.cName = unitName;
					// this.formData.unitNature = [unitNature]
					this.formData.unitType = organizationType;
					this.formData.industry = theirIndustry;
					this.formData.techField = belongsToField;
					this.formData.coAddress = registeredAddress;
					this.formData.address = detailedAddress;
					// 注册资本
					registeredCapital = (registeredCapital + '').replace('万元', '')
					this.formData.reCapital = (Math.floor(registeredCapital*100) /100).toFixed(2) + '万元';
				}
				return data;
			}
		});
	}
	submit() {
		if (!(this.$refs.companyBaseInfo as any).validForm()) {
		}
	}
	save() {
		const {
			cName: unitName,
			unitNature,
			socialIdCard: creditCode,
			unitType: organizationType,
			industry: theirIndustry,
			reCapital: registeredCapital,
			address: detailedAddress,
			coAddress: registeredAddress,
			techField: belongsToField
		} = this.formData;
		const options = {
			unitName,
			unitNature: unitNature[0],
			creditCode,
			organizationType: organizationType[0],
			theirIndustry: theirIndustry[0],
			registeredCapital,
			registeredAddress,
			detailedAddress,
			belongsToField: belongsToField[0],
			id: this.unitId
		};
		this.addBasic(options).then(({ code, data, msg }: any) => {
			if (code === 0) {
				this.$message.success("提交成功");
				return data;
			}
		});
	}
	// save(type: any) {
	//   switch (type) {
	//   case 0: this.addBasicData();break;
	//   case 1: this.addBasicData();break;
	//   case 2: this.addBasicData();break;
	//   default: break;
	//   }
	// }
}
